"use strict";

var _regeneratorRuntime = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dsv_parser_1 = require("./dsv_parser");

var DatasetLoader =
/*#__PURE__*/
function () {
  function DatasetLoader() {
    _classCallCheck(this, DatasetLoader);
  }

  _createClass(DatasetLoader, [{
    key: "loadTextData",
    value: function loadTextData(url) {
      return fetch(url).then(function (resp) {
        return resp.text();
      });
    }
  }, {
    key: "loadCSVFromURL",
    value: function loadCSVFromURL(url) {
      return this.loadTextData(url).then(function (data) {
        return dsv_parser_1.parseDataset(url, data, "csv");
      });
    }
  }, {
    key: "loadTSVFromURL",
    value: function loadTSVFromURL(url) {
      return this.loadTextData(url).then(function (data) {
        return dsv_parser_1.parseDataset(url, data, "tsv");
      });
    }
  }, {
    key: "loadCSVFromContents",
    value: function loadCSVFromContents(filename, contents) {
      return dsv_parser_1.parseDataset(filename, contents, "csv");
    }
  }, {
    key: "loadTSVFromContents",
    value: function loadTSVFromContents(filename, contents) {
      return dsv_parser_1.parseDataset(filename, contents, "csv");
    }
  }, {
    key: "loadTableFromSourceSpecification",
    value: function loadTableFromSourceSpecification(spec) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var tableContent, format, table, _table;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!spec.url) {
                  _context.next = 11;
                  break;
                }

                _context.next = 3;
                return this.loadTextData(spec.url);

              case 3:
                tableContent = _context.sent;
                format = "csv";

                if (spec.url.toLowerCase().endsWith(".tsv")) {
                  format = "tsv";
                }

                table = dsv_parser_1.parseDataset(spec.url.split("/").pop(), tableContent, format);

                if (spec.name) {
                  table.name = spec.name;
                }

                return _context.abrupt("return", table);

              case 11:
                if (!spec.content) {
                  _context.next = 17;
                  break;
                }

                _table = dsv_parser_1.parseDataset(spec.name, spec.content, spec.format);
                _table.name = spec.name;
                return _context.abrupt("return", _table);

              case 17:
                throw new Error("invalid table specification, url or content must be specified");

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "loadDatasetFromSourceSpecification",
    value: function loadDatasetFromSourceSpecification(spec) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this = this;

        var tables, dataset;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Promise.all(spec.tables.map(function (table) {
                  return _this.loadTableFromSourceSpecification(table);
                }));

              case 2:
                tables = _context2.sent;
                // Make dataset struct
                dataset = {
                  name: spec.name,
                  tables: tables
                };

                if (!spec.name && tables.length > 0) {
                  dataset.name = tables[0].name;
                }

                return _context2.abrupt("return", dataset);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }]);

  return DatasetLoader;
}();

exports.DatasetLoader = DatasetLoader;